import React from 'react'
import { withTranslation } from 'react-i18next'
import { PageHeading } from '../components/Fragments'

function Contact({ t }) {
  return (
    <>
      <PageHeading
        pageTitle='menu.contact'
        acronym='acronym'
        researchCenter='cavas_research_center'
      />

      <p className='uk-text-lead'>{t('pages.contact.part1')}</p>
      <p className='uk-text-lead'>{t('pages.contact.part2')}</p>
      <address>{t('pages.contact.part3')}</address>
      <p>
        <a href='https://www.ulbsibiu.ro/en/' target='_blank' rel='noreferrer'>
          https://www.ulbsibiu.ro/ro/
        </a>
      </p>
      <p>
        <a href='/'>{t('pages.contact.part5')}</a>
      </p>
      <p>
        <a href={`mailto:${t('pages.contact.part4')}`}>
          {t('pages.contact.part4')}
        </a>
      </p>
      <p>
        <a href={`mailto:${t('pages.contact.part6')}`}>
          {t('pages.contact.part6')}
        </a>
      </p>
      <p>
        <a href={`mailto:${t('pages.contact.part7')}`}>
          {t('pages.contact.part7')}
        </a>
      </p>
    </>
  )
}

export default withTranslation()(Contact)
